import { Attachment } from './attachment';
import { Metric } from './metric';
import { Project } from './project';
import { User } from './user';

export type ActionType = 'corrective' | 'preventive' | 'improvement';
export type ActionPriority = 'low' | 'medium' | 'high' | 'critical';
export type ActionStatus = 'todo' | 'in_progress' | 'done' | 'closed' | 'cancelled';
export type ActionEffectiveness = 'pending' | 'effective' | 'partially_effective' | 'ineffective';
export type ActionSource = 'risk' | 'manual' | 'audit' | 'other';

export interface ActionStatusHistory {
    status: ActionStatus;
    changedAt: string;
    changedBy?: User | string;
    changedByName?: string;
    comment?: string;
}

export interface ActionComment {
    id?: string;
    text: string;
    createdAt: string;
    createdBy?: User | string;
    createdByName?: string;
}

export interface Action {
    _id?: string;
    id: string;
    project?: Project | string;
    title: string;
    description?: string;
    type: ActionType;
    priority: ActionPriority;
    status: ActionStatus;
    source: ActionSource;
    assignee?: User | string;
    assigneeName?: string;
    dueDate?: string;
    completionDate?: string;
    effectiveness?: ActionEffectiveness;
    effectivenessNote?: string;
    risks?: (Metric | string)[];
    riskTitles?: string[];
    attachments?: Attachment[] | string[];
    comments?: ActionComment[];
    statusHistory?: ActionStatusHistory[];
    createdDate: string;
    createdBy?: User | string;
    createdByName?: string;
    updatedDate?: string;
}

export interface PostAction {
    project?: string;
    title: string;
    description?: string;
    type: ActionType;
    priority: ActionPriority;
    status?: ActionStatus;
    source: ActionSource;
    assignee?: string;
    dueDate?: string;
    risks?: string[];
    riskTitles?: string[];
    attachments?: string[];
}

export interface PutAction {
    id: string;
    title?: string;
    description?: string;
    type?: ActionType;
    priority?: ActionPriority;
    status?: ActionStatus;
    assignee?: string;
    dueDate?: string;
    completionDate?: string;
    effectiveness?: ActionEffectiveness;
    effectivenessNote?: string;
    risks?: string[];
    riskTitles?: string[];
    attachments?: string[];
    statusChangeComment?: string;
}

export const defaultAction: Partial<Action> = {
    title: '',
    description: '',
    type: 'corrective',
    priority: 'medium',
    status: 'todo',
    source: 'manual',
};
